import React, { useState, Component } from 'react';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MoreInfoDialog, { Item } from "../../../Utils/MoreInfoDialog";
import { faPen, faInfo, faPlay, faPowerOff, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const moment = require("moment");


const ServiceRow = ({ user, selectUser, enableUser, disableUser, userDeleteBtn, ...props }) => {

  const {filters} = useSelector(state => ({filters: state.filters}));
  const version = (user.device_info && user.device_info["app-version"]) ? user.device_info["app-version"][0] : 0;
  //console.log("hello", user);
  const upToDate = filters.app_version === version;
  const [showMembers, setShowMembers] = useState(false);
  const [showShifts, setshowShifts] = useState(false);
  
  var problem_types;

  const getProblems = (problems) => 
  problems.map(problem => {
      return problem_types = problem.problem_type + " / \n"; 
  }
  );

  return (
    <React.Fragment>
    <div className={"row "}>
    <div className={"col-md-12"}>

    <div className={"row ctable-row"}>
      <div className={"col-md-2"}>
        <div className={"agent-list-profile"}>
          <div className={"col-profile-ct"}>
            <span className={"agent-list-photo task-status status-id-2"}>{user.name}</span>
            {/*<span className={"agent-list-username"}>
              <span>{user.username}</span>
              <span className={"status-id-1"}>
                <abbr>{user.cluster}</abbr>
              </span>
            </span>*/}
          </div>
        </div>
      </div>

      <div className={"col-md-1"}>{user.email ? user.email : ""}</div>
      <div className={"col-md-1"}>{user.cluster_manager_username ? user.cluster_manager_username : ""}</div>
      <div className={"col-md-2"}> {getProblems(user.problems)} 
      </div>
      {/*<div className={"col-md-2"}>{user.phone}</div>
      <div className={"col-md-2 site-plan-col-date"}>
        <span>
          {user.last_online
            ? moment(user.last_online)
                .format("YYYY-MM-DD HH:mm")
                .toString()
            : "Jamais"}
        </span>
        {user.device_info && user.device_info["app-version"] ? (
          <span className={"app-version-tag "+(upToDate ? "btn-success" : "btn-danger")}>{user.device_info["app-version"][0]}</span>
        ) : (
          ""
        )}
      </div>
      <div className={"col-md-2"}>{user.sites}</div>*/}

      <div className={"col-md-1"}>{user.cluster ? user.cluster.toUpperCase() : ""}</div>

      <div className={"col-md-1"}>
        <span className={user.web_escalation =='true' ? "agent-list-photo task-status status-id-5" : "agent-list-photo task-status status-id-4"}>{user.web_escalation =='true' ? "Oui" : "Non"}</span>
      </div>

      <div className={"col-md-1"}>
      <span className={user.mobile_escalation =='true' ? "agent-list-photo task-status status-id-5" : "agent-list-photo task-status status-id-4"}>{user.mobile_escalation == 'true' ? "Oui" : "Non"}</span>
      </div>

      <div className={"col-md-1"}>
      <span className={user.external =='false' ? "agent-list-photo task-status status-id-5" : "agent-list-photo task-status status-id-4"}>{user.external == 'true' ? "Oui" : "Non"}</span>
      </div>

      <div className={"col-md-2 task-details-col"}>
        <button onClick={() => setShowMembers(!showMembers)} className="task-action-btn" ><FontAwesomeIcon icon={faChevronDown}  /> Membres</button>

        {/*<Link to={"/services/" + user.service_id} className={"task-action-btn ml-1 "}>
          <FontAwesomeIcon icon={faInfo} /> Details
        </Link>*/}
        {user.status !== "deleted" ? (
          <>
            <MoreInfoDialog>
              <Item onClick={() => selectUser(user)}>
                <FontAwesomeIcon className={"mr-2 "} icon={faPen} /> Modifier
              </Item>
              {/*user.status === "disabled" ? (
                <Item onClick={() => enableUser(user.userid)}>
                  <FontAwesomeIcon className={"mr-2 "} icon={faPlay} /> Activer
                </Item>
              ) : (
                <Item onClick={() => disableUser(user.userid)}>
                  <FontAwesomeIcon className={"mr-2 "} icon={faPowerOff} /> Désactiver
                </Item>
              )*/}
              <Item onClick={() => userDeleteBtn(user.service_id)}>
                <FontAwesomeIcon className={"mr-2 "} icon={faTrash} /> Supprimer
              </Item>
            </MoreInfoDialog>
          </>
        ) : (
          <b>ACCOUNT DELETED</b>
        )}

      </div>
    </div>

      {!!showMembers && (
        <>
        <div className={"animateRow row"}>
          <div className={"col-md-4"}><b>Username</b></div>
          {/*<div className={"col-md-1"}><b>Agent Id</b></div>*/}
         {/* <div className={"col-md-3"}><b>Matricule</b></div>*/}
          <div className={"col-md-4"}><b>Nom</b></div>
          <div className={"col-md-4"}><b>Téléphone</b></div>
          {/*<div className={"col-md-2"}><b>Email</b></div>*/}
        </div>
          <div className={"animateRow row"}>
          {user.managers.map(manager => (
            <>
              <div className={"col-md-4"}>
                <div className={"agent-list-profile"}>
                  <div className={"col-profile-ct"}>
                    <span className={"agent-list-photo task-status status-id-2"}>{manager.manager_username}</span>
                  </div>
                </div>
              </div>
              {/*<div className={"col-md-1"}>{manager.manager_id}</div>*/}
              {/*<div className={"col-md-3"}>{manager.manager_matricule}</div>*/}
              <div className={"col-md-4"}>{manager.manager_first_name + " " + manager.manager_last_name}</div>
              <div className={"col-md-4"}>{manager.manager_phone}</div>
              {/*<div className={"col-md-2"}>{manager.manager_email}</div>*/}
            </>
          ))}
          </div>
        </>
      )}

      </div>
      </div>
      </React.Fragment>
  );
};

export default ServiceRow;
